
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section-front/[[...slug]]",
      function () {
        return require("private-next-pages/section-front/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section-front/[[...slug]]"])
      });
    }
  